export default "__VITE_ASSET__qDv9qBaa__"